import React from 'react';
import './About.css';

import ASCIIAlien from '../Images/ascii-alien.png';

function About() {
  return (
    <div className="about-container">
      <h1>About Me</h1>
      <p>
       Hello everyone, my name is Alyssa Wiser and I created this blog to help document my journey into building and creating tech, but I also just wanted to create a space where I can express myself and organize my thoughts. Also looks good on a resume haha. I'm currently 25 years old, and I'm working as support for a laboratory information system (LIS). I have a passion for creating and building things, both physically and digitally. I went to school for Software Engineering in 2022 at Southern New Hampshire University and that is where I really learned the fundamentals of coding, specifically Javascript and React. I am actually using React to create this blog, but I want to experiment with C# and Python, so I will probably be linking some Github links to future projects here. So be on the lookout for that. Anyway, welcome to my blog. 
      </p>
      <div className='ascii-alien'>
        <img src={ASCIIAlien} alt="ASCII Alien" />
      </div>
    </div>
  );
}

export default About;